import { render } from "./BlockRadioGroupSelect.vue?vue&type=template&id=23449a01&scoped=true"
import script from "./BlockRadioGroupSelect.vue?vue&type=script&lang=js"
export * from "./BlockRadioGroupSelect.vue?vue&type=script&lang=js"

import "./BlockRadioGroupSelect.vue?vue&type=style&index=0&id=23449a01&lang=less&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23449a01"]])

export default __exports__